module.exports = __webpack_public_path__ + "img/Login-1.68bb0171.png";